export const formatValue = (value: any, type: string, fieldName: string) => {
    switch (type) {
        case 'relationship':
            return formatRelationshipValue(value, fieldName);
        case 'phone':
            return formatPhoneValue(value);
        case 'linked-lead-date':
            // Return the full object so the cell component has access to lead info
            return value;
        default:
            return formatStringValue(value, type);
    }
};

export const formatRelationshipValue = (value: any, fieldName: string) => {
    switch (fieldName) {
        case 'creator':
        case 'origin':
        case 'owner':
        case 'territory':
        case 'market':
        case 'industry':
        case 'accountType':
        case 'primaryAccountOwner': {
            return formatRelationshipStringValue(value);
        }
        case 'accounts':
        case 'contacts':
        case 'products':
        case 'sources':
        case 'channels':
            return formatRelationshipArrayValue(value);
        default: {
            return formatTokenizedValue(value);
        }
    }
};

export type PhoneValue = {
    value: string;
    valueRaw: string;
};

export const formatPhoneValue = (value: any): PhoneValue | null | undefined => {
    if (!value || !value.value) {
        return null;
    }

    return {
        value: value.value,
        valueRaw: value.valueRaw,
    };
};

export const formatStringValue = (value: any, type: string) => {
    if (!value) {
        return null;
    } else if (typeof value === 'string') {
        return value;
    } else if (value && value.value && type === 'integer' && !isNaN(value.value)) {
        return value.value.toLocaleString();
    } else {
        return value.value;
    }
};

export const formatRelationshipArrayValue = (
    value?: {
        value: any[];
    } | null
): any[] | null | undefined => {
    if (!value || !value.value || !value.value.length) return null;

    return value.value.map((item) => item.value);
};

export const formatRelationshipStringValue = (value: any) => {
    return value && value.value ? value.value.name || value.value.value : undefined;
};

export const formatTokenizedValue = (value: any) => {
    if (!value || !value.value || !value.value.length) return null;

    // @ts-expect-error
    return value.value.map((item) => item.value);
};
